import { PlusCircleIcon } from '@heroicons/react/24/outline';
import { Group, Space, Stack, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import {
  AddPortfolioItemForm,
  PortfolioItemCard
} from '@/features/artist/portfolio';
import { PageLoading } from '@/pages/PageLoading';
import { useArtistWorkHistory } from '@/pages/artist/onboard/components/stages/work/hooks/useArtistWorkHistory.ts';
import { translate } from '@/shared/i18n/translate';
import { LBModalFullscreenLayout } from '@/shared/layouts/modal/ModalFullScreenLayout';
import {
  LBButton,
  LBLinkButton,
  LBModalHeader
} from '@/shared/ui-kit/components';

export const ArtistWorkHistory = () => {
  const { functions, state } = useArtistWorkHistory();
  const [opened, { open, close }] = useDisclosure(false);

  if (state.isLoading) return <PageLoading />;

  return (
    <div style={{ height: '100%', position: 'relative' }}>
      <LBModalFullscreenLayout opened={opened} onClose={close}>
        <LBModalHeader onClose={close} />
        <Space h={32} />
        <AddPortfolioItemForm
          existUntilNow={state.worksHistory.data?.data.some(
            (item) => item.untilNow === true
          )}
          onSuccess={close}
        />
      </LBModalFullscreenLayout>
      <Title order={1}>{translate('pages.onboarding.artist.work.title')}</Title>
      <Space h={32} />
      <Stack>
        {state.worksHistory.data?.data.map((item, index) => (
          <PortfolioItemCard
            key={item.clubName + index}
            clubCountry={item.clubCountry}
            clubName={item.clubName}
            endDate={item.endDate}
            jobRole={item.jobRole}
            startDate={item.startDate}
            untilNow={item.untilNow}
            onDelete={() => functions.onDelete(index)}
          />
        ))}
      </Stack>

      <Space h={32} />
      <LBLinkButton leftsection={<PlusCircleIcon width={18} />} onClick={open}>
        {translate('pages.onboarding.artist.work.addWorkPlace')}
      </LBLinkButton>
      <Space h={32} />
      <Group bottom={60} pos='sticky'>
        {!state.worksHistory.data?.data.length && (
          <LBButton
            fullWidth
            variant='outline'
            onClick={functions.continueWithoutExperience}
          >
            {translate('pages.onboarding.artist.work.notHaveWorkExperience')}
          </LBButton>
        )}

        {state.worksHistory.data?.data.length && (
          <LBButton fullWidth onClick={functions.continueWithExperience}>
            {translate('commons.save-and-continue')}
          </LBButton>
        )}
      </Group>
    </div>
  );
};
